import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

const USER_KEY = 'currentUser';
const PIPEDRIVE_KEY = 'pipedrive';
const SECRET_KEY = '8c9ea259776fd4fd4f64ac2a1185758993ea66413aebd2bb1d97bfa487702ba8';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  constructor() {}

  public clearAll(): void {
    window.sessionStorage.clear();
    window.localStorage.clear();
  }

  public setCurrentUser(user: any): void {
    this.encryptAndStore(USER_KEY, user);
  }

  public getCurrentUser(): any {
    return this.retrieveAndDecrypt(USER_KEY);
  }

  private encryptAndStore(key: string, data: any): void {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    window.localStorage.setItem(key, encrypted);
  }

  private retrieveAndDecrypt(key: string): any {
    const encrypted = window.localStorage.getItem(key);
    if (!encrypted) return null;
    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch {
      return null;
    }
  }
}
